import * as React from "react";
import { styled } from "@mui/system";
import MUIGrid, { GridProps } from "@mui/material/Grid";

export const Grid = styled((props: GridProps) => <MUIGrid {...props} />, {
  name: "Grid",
  slot: "Root",
  overridesResolver: (props, styles) => [],
})(({ theme }) => ({}));
